<div class="w-full h-full flex justify-center">
    <div class="w-3/4 h-full px-8">
        <div class="card w-full">
            <div class="flex justify-evenly gap-6">
                <div class="w-full">
                    <h2>Welcome to <span class="text-lrpTicketBlack font-extrabold me-5"><span class="tracking-widest text-lrpTicketBlue">LRP</span> Tickets</span></h2>
                    <p class="text-sm mb-3">To reset your password please enter your e-mail address and we will send you an e-mail with a link to reset your password.</p>
                    <p class="text-sm mb-3">If you have remembered your details, <a routerLink="/login" class="underline cursor-pointer">click here to login.</a></p>
                </div>
                <div class="w-full pt-8 mb-3" >
                    <div class="flex flex-col mb-3">
                        <label for="e-mail">Your e-mail address</label>
                        <input type="email" required id="email" name="email" [formControl]="resetEmailControl">
                        @if (code){
                            <input type="hidden" id="code" name="code" [formControl]="resetCode" />
                        }
                    </div>
                    @if (code){
                        <div class="flex justify-evenly gap-4 mb-3 w-full">
                            <div class="flex flex-col w-full">
                                <label for="password" class="text-sm">Enter a Password</label>
                                <input type="password" required id="password" name="password" [formControl]="resetPassword" placeholder="Password">
                            </div>
                            <div class="flex flex-col w-full">
                                <label for="password_confirmation" class="text-sm">Confirm Your Password</label>
                                <input type="password" required id="password_confirmation" name="password_confirmation" [formControl]="resetPasswordConfirm" placeholder="Confirm Password">
                            </div>
                        </div>
                    }
                    <button class="primaryButton w-full" [disabled]="!resetEmailControl.valid" (click)="requestPasswordReset()">Reset My Password</button>
                </div>
            </div>
        </div>
        <div class="mt-10 ">
            @if (eventSystems$ | async; as eventSystems){
                <h1 class="text-center !text-lrpTicketBlack">Look out for events from our supported event systems</h1>
                <div class="flex justify-evenly">
                    @for (eventSystem of eventSystems; track $index){
                        @if (eventSystem.img){
                            <img [src]="eventSystem.img.url" [alt]="eventSystem.name" [routerLink]="'/system/' + eventSystem.systemRef" class="max-h-12 cursor-pointer" />
                        }
                    }
                </div>
            }
        </div>
    </div>
</div>